<template>
  <div>
    <v-row dense>
      <v-col cols="12">

        <p_addr v-model="address" :easyModeFlag="true" @input="setAddress" 
        
        :key="address.ApplicantAddressID" />


      </v-col>
    
      <v-col cols="12" md="3"> 
        <p_dd @input="setAddress" :label="$t('labels.ResidentialStatusR')" menu="ResidentialStatus"
         v-model="address.ResidentialStatusDD" />
      </v-col>
      <v-col cols="12" md="3" v-if="address.ResidentialStatusDD == 2">
        <p_money :label="$t('labels.RentR')" v-model="address.Rent" />
      </v-col>
        <v-col cols="12" md="3">
            <v-text-field type="number" :label="$t('labels.TimeYear')" v-model="y" @input="setAddress" />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field type="number" :label="$t('labels.TimeMonth')" v-model="m" @input="setAddress" />
          </v-col>
    </v-row>
  </div>
</template>

<script>
import p_addr from "@/shared/components/addr";
import model from "@/shared/dataModels/app";
import p_dd from "@/shared/components/ddSelect";
import p_money from "@/shared/components/money";
export default {
  props: ["value"],
  components: {
    p_addr,
    p_dd,
    p_money
  },
  data() {
    return {
      updateIndex: 0,
      readyFlag: false,
      address: model.getApplicantAddressModel(),

      y: null,
      m: null
    };
  },
  methods: {
    getMonthsAtAddress() {
      let rv = 0;
      try {
        if (this.y) {
          rv = this.y * 12;
        }
        if (this.m) rv = Number(rv) + Number(this.m);
      } catch (err) {
        rv = 0;
      }
      return rv;
    },
    setAddress() {
      // console.log('setaddress', this.address);
      this.address.MonthsAtAddress = this.getMonthsAtAddress();

      this.$emit("input", this.address);
    },
    setValue() {
      if (this.readyFlag) return;
      setTimeout(() => {
        if (this.value) {
          this.address = this.value;

          this.y = Math.floor(this.address.MonthsAtAddress / 12);
          this.m = this.address.MonthsAtAddress % 12;

          this.updateIndex++;
          this.$forceUpdate();
          this.readyFlag = true;
        } else {
          this.setValue();
        }
      }, 500);
    }
  },
  mounted() {
    this.setValue();
  },
  watch:{
    y(n) {
      if (n < 0) {
        n = 0;
        this.$nextTick(() => {
          this.y = null;
        });
      }
      this.$nextTick(() => {
        this.y = Number(n);
        if(this.y > 83){
        this.y = 83;
      }
      });
    },
    m(n) {
      if (n < 0) {
        n = 0;
        this.$nextTick(() => {
          this.m = null;
        });
      }
      this.$nextTick(() => {
        this.m = Number(n);
        if(this.m > 3 && this.y == 83){
        this.m = 3;
      }
      let monthAtWork = 0;
      if (this.y) monthAtWork = this.y * 12;
      if (this.m) monthAtWork += this.m;
      if(monthAtWork > 1000){
        this.y = 83;
        this.m = 3;
      }
      });
     
    }
  }
};
</script>

<style></style>
